"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.validateCreator = validateCreator;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));
var _actions = require("../../actions");
var _utils = require("../../utils");
function validateCreator(getState, dispatch) {
  return (inputNames = [], shouldPerformValidityEffects = true) => {
    const {
      inputStates
    } = getState();
    const inputsMap = inputNames && inputNames.length ? (0, _utils.getInputsWithNames)(inputStates, inputNames) : inputStates;
    let areAllSpecifiedInputsValid = true;
    (0, _forEach.default)(inputsMap).call(inputsMap, (inputState, inputElement) => {
      const isInputValid = (0, _actions.validateInput)(inputElement)(getState, dispatch);
      if (!isInputValid) {
        areAllSpecifiedInputsValid = false;
      }
    });
    dispatch((0, _actions.performValidityEffects)(areAllSpecifiedInputsValid, shouldPerformValidityEffects));
    return areAllSpecifiedInputsValid;
  };
}